import { z } from 'zod';
/**
 * Deployment an engagement runs against. Production is listed because customers do
 * authorise production testing, but it is never a default and the scope approval gate
 * (§5) is what actually permits it.
 */
export const EnvironmentSchema = z.enum(['UAT', 'STAGING', 'PRODUCTION']);
/** Business criticality of the application under test. Drives triage ordering, not permissions. */
export const CriticalitySchema = z.enum(['LOW', 'MEDIUM', 'HIGH', 'CRITICAL']);
/**
 * What a component of an application is, as the person who registers it describes it.
 *
 * Declared, not inferred: a scan sees URLs, never that `/rest` is the API or that the API reads a
 * database. The kind decides how the surface map draws the component and nothing else — it
 * grants no permission and widens no scope.
 */
export const ComponentKindSchema = z.enum([
    'WEB_FRONTEND',
    'API',
    'AUTHENTICATION',
    'ADMIN',
    'STATIC_CONTENT',
    'FILE_STORE',
    'DATA_STORE',
    'THIRD_PARTY',
    'OTHER',
]);
/** Kinds a scanner can reach from outside. The others are drawn behind them, never probed. */
export const EDGE_COMPONENT_KINDS = new Set([
    'WEB_FRONTEND',
    'API',
    'AUTHENTICATION',
    'ADMIN',
    'STATIC_CONTENT',
    'FILE_STORE',
]);
//# sourceMappingURL=application.js.map